module.exports = __webpack_public_path__ + "img/bg_7.eeeb3aa9.png";